/* The Wall Studio - store features: cart drawer, wishlist, recently viewed, modals. */
(function () {
  'use strict';

  var doc = document;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE = ROOT.charAt(ROOT.length - 1) === '/' ? ROOT.slice(0, -1) : ROOT;
  var FMT = window.TWS_MONEY_FORMAT || 'Rs.{{amount}}';

  function group(intPart) {
    var out = '', c = 0;
    for (var i = intPart.length - 1; i >= 0; i--) {
      out = intPart.charAt(i) + out;
      c++;
      if (c % 3 === 0 && i > 0) out = ',' + out;
    }
    return out;
  }
  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    var noDec = FMT.indexOf('no_decimals') !== -1;
    var value = group(parts[0]) + (noDec ? '' : '.' + parts[1]);
    var o = FMT.indexOf('{{'), c = FMT.indexOf('}}');
    if (o === -1 || c === -1) return value;
    return FMT.slice(0, o) + value + FMT.slice(c + 2);
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;');
  }
  function img(url, w) {
    if (!url) return '';
    return url.indexOf('?') === -1 ? url + '?width=' + w : url + '&width=' + w;
  }
  function openDrawer(d) {
    if (!d) return;
    d.classList.add('is-open');
    doc.body.classList.add('body-locked');
  }

  /* ================= CART DRAWER ================= */
  var drawer = null;
  function cartEls() {
    if (!drawer) drawer = doc.getElementById('CartDrawer');
    return drawer;
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function paintCount(cart) {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }
  function lineProps(item) {
    if (!item.properties) return '';
    var out = '';
    for (var k in item.properties) {
      if (!Object.prototype.hasOwnProperty.call(item.properties, k)) continue;
      if (k.charAt(0) === '_') continue;
      var val = item.properties[k];
      if (!val) continue;
      if (String(val).indexOf('/uploads/') !== -1) {
        out += '<span>' + esc(k) + ': <a href="' + esc(val) + '" target="_blank" rel="noopener">View file</a></span>';
      } else {
        out += '<span>' + esc(k) + ': ' + esc(val) + '</span>';
      }
    }
    return out ? '<div class="cd-line__props">' + out + '</div>' : '';
  }

  function renderCart(cart) {
    var d = cartEls();
    if (!d) return;
    var body = d.querySelector('[data-cart-body]');
    var foot = d.querySelector('[data-cart-foot]');
    var qty = d.querySelector('[data-cart-qty]');
    if (qty) qty.textContent = cart.item_count;

    if (!cart.item_count) {
      body.innerHTML = '<div class="cd-empty"><h3 class="h3">Your cart is empty</h3>' +
        '<p>Start with a collection, or tell us what you would like framed.</p></div>';
      foot.innerHTML = '<div class="cd-actions">' +
        '<a class="btn btn--full" href="' + BASE + '/collections/all">Shop artwork</a>' +
        '<a class="btn btn--ghost btn--full" href="' + BASE + '/pages/contact">Contact us</a></div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, i) {
      var variantLine = item.product_has_only_default_variant ? '' :
        '<div class="cd-line__meta">' + esc(item.variant_title || '') + '</div>';
      html += '<div class="cd-line" data-line="' + (i + 1) + '">' +
        (item.image
          ? '<a href="' + esc(item.url) + '"><img class="cd-line__img" src="' + esc(img(item.image, 220)) + '" alt="' + esc(item.product_title) + '" width="72" height="90" loading="lazy"></a>'
          : '<span class="cd-line__ph"></span>') +
        '<div>' +
          '<a class="cd-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          variantLine +
          lineProps(item) +
          '<div class="cd-line__row">' +
            '<span class="cd-qty">' +
              '<button type="button" data-line-qty="down" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-line-qty="up" aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<span class="cd-line__price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cd-remove" data-line-remove>Remove</button>' +
        '</div>' +
      '</div>';
    });

    html += '<details class="cd-note"' + (cart.note ? ' open' : '') + '>' +
      '<summary>Add a note for us</summary>' +
      '<textarea data-cart-note rows="3" placeholder="Custom sizes, delivery instructions, a gift message">' + esc(cart.note || '') + '</textarea>' +
      '</details>';
    body.innerHTML = html;

    foot.innerHTML =
      '<div class="cd-ship">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M2 6h11v10H2z"/><path d="M13 9h4.5l3.5 3.5V16H13z"/><circle cx="6.5" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>' +
        '<span>Delivery across Pakistan</span>' +
      '</div>' +
      '<div class="cd-total"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<p class="cd-fine">Taxes and shipping calculated at checkout. Discount codes are applied at checkout.</p>' +
      '<div class="cd-actions">' +
        '<button type="button" class="btn btn--full" data-cart-checkout>Checkout</button>' +
        '<a class="btn btn--ghost btn--full" href="' + BASE + '/cart">View full cart</a>' +
      '</div>';
  }

  function refreshCart(open) {
    return getCart().then(function (cart) {
      renderCart(cart);
      paintCount(cart);
      if (open) openDrawer(cartEls());
      return cart;
    });
  }

  function changeLine(line, quantity) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      paintCount(cart);
    });
  }

  doc.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-ajax-cart]') : null;
    if (!form) return;
    if (e.submitter && e.submitter.hasAttribute('data-direct-checkout')) return;
    var hasFiles = Array.prototype.some.call(form.querySelectorAll('input[type="file"]'), function (field) { return field.files && field.files.length; });
    if (hasFiles) return;
    if (!cartEls()) return;

    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('[data-add]');
    var text = btn && btn.querySelector('[data-add-text]');
    var prev = text ? text.textContent : '';
    if (text) text.textContent = 'Adding...';

    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (text) text.textContent = prev;
        if (!res.ok) {
          if (text) text.textContent = res.data.description || 'Unavailable';
          setTimeout(function () { if (text) text.textContent = prev; }, 2400);
          return;
        }
        refreshCart(true);
      })
      .catch(function () { form.submit(); });
  }, true);

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-cart-open]') && cartEls()) {
      e.preventDefault();
      refreshCart(true);
      return;
    }

    var q = t.closest('[data-line-qty]');
    if (q) {
      var row = q.closest('[data-line]');
      var line = parseInt(row.getAttribute('data-line'), 10);
      var cur = parseInt(row.querySelector('.cd-qty span').textContent, 10);
      changeLine(line, q.getAttribute('data-line-qty') === 'up' ? cur + 1 : Math.max(0, cur - 1));
      return;
    }

    var rm = t.closest('[data-line-remove]');
    if (rm) {
      var r2 = rm.closest('[data-line]');
      changeLine(parseInt(r2.getAttribute('data-line'), 10), 0);
      return;
    }

    if (t.closest('[data-cart-checkout]')) {
      var note = doc.querySelector('[data-cart-note]');
      var go = function () { window.location.href = BASE + '/checkout'; };
      if (note) {
        fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).then(go).catch(go);
      } else { go(); }
      return;
    }

    var mOpen = t.closest('[data-modal-open]');
    if (mOpen) {
      e.preventDefault();
      var m = doc.getElementById(mOpen.getAttribute('data-modal-open'));
      if (m) { m.classList.add('is-open'); doc.body.classList.add('body-locked'); }
      return;
    }
    if (t.closest('[data-modal-close]') || (t.classList && t.classList.contains('modal__scrim'))) {
      var mm = t.closest('.modal');
      if (mm) { mm.classList.remove('is-open'); doc.body.classList.remove('body-locked'); }
      return;
    }

    var w = t.closest('[data-wish]');
    if (w) { e.preventDefault(); toggleWish(w); return; }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = doc.querySelector('.modal.is-open');
    if (m) { m.classList.remove('is-open'); doc.body.classList.remove('body-locked'); }
  });

  /* ================= WISHLIST ================= */
  var WKEY = 'tws:wishlist';
  function wishRead() {
    try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (err) { return []; }
  }
  function wishWrite(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (err) {}
    paintWishCount();
  }
  function paintWishCount() {
    var n = wishRead().length;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-wish-count]'), function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function paintWishButtons() {
    var list = wishRead();
    Array.prototype.forEach.call(doc.querySelectorAll('[data-wish]'), function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wish')) !== -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = btn.querySelector('[data-wish-text]');
      if (lbl) lbl.textContent = on ? 'Saved' : 'Save for later';
    });
  }
  function toggleWish(btn) {
    var handle = btn.getAttribute('data-wish');
    if (!handle) return;
    var list = wishRead();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    wishWrite(list);
    paintWishButtons();
    if (doc.querySelector('[data-wish-grid]')) renderWishlist();
  }

  /* ================= RECENTLY VIEWED ================= */
  var RKEY = 'tws:recent';
  function recordRecent(handle) {
    if (!handle) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (err) {}
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RKEY, JSON.stringify(list.slice(0, 8))); } catch (err) {}
  }

  /* ================= CARD RENDERER ================= */
  function cardHtml(p) {
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var was = onSale ? '<span class="money--was">' + money(p.compare_at_price) + '</span> ' : '';
    var badge = onSale
      ? '<span class="card__badge card__badge--sale">-' + Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100) + '%</span>'
      : '';
    var media = p.featured_image
      ? '<img src="' + esc(img(p.featured_image, 720)) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="750">'
      : '<span style="display:block;width:100%;height:100%;background:var(--c-bg-deep)"></span>';
    return '<div class="card">' +
      '<div class="card__media">' + media + badge +
        '<button type="button" class="wish-btn" data-wish="' + esc(p.handle) + '" aria-label="Save ' + esc(p.title) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 20s-7-4.4-7-9.3A4 4 0 0 1 12 8a4 4 0 0 1 7 2.7C19 15.6 12 20 12 20Z" stroke-linejoin="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="card__body">' +
        '<h3 class="card__title"><a class="card__link" href="' + BASE + '/products/' + esc(p.handle) + '">' + esc(p.title) + '</a></h3>' +
        '<p class="card__price">' + was + money(p.price) + '</p>' +
      '</div></div>';
  }

  function fetchProducts(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch(BASE + '/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) { return list.filter(Boolean); });
  }

  function renderWishlist() {
    var grid = doc.querySelector('[data-wish-grid]');
    if (!grid) return;
    var empty = doc.querySelector('[data-wish-empty]');
    var handles = wishRead();
    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    fetchProducts(handles).then(function (items) {
      grid.innerHTML = items.map(cardHtml).join('');
      paintWishButtons();
    });
  }

  function renderRecent() {
    var wrap = doc.querySelector('[data-recent]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-recent-grid]');
    var current = wrap.getAttribute('data-recent');
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (err) {}
    handles = handles.filter(function (h) { return h !== current; }).slice(0, 4);
    if (!handles.length) { wrap.hidden = true; return; }
    fetchProducts(handles).then(function (items) {
      if (!items.length) { wrap.hidden = true; return; }
      grid.innerHTML = items.map(cardHtml).join('');
      wrap.hidden = false;
      paintWishButtons();
    });
  }

  function init() {
    paintWishCount();
    paintWishButtons();
    var pdp = doc.querySelector('[data-product-handle]');
    if (pdp) recordRecent(pdp.getAttribute('data-product-handle'));
    renderRecent();
    renderWishlist();
    if (cartEls()) getCart().then(renderCart).catch(function () {});
  }

  if (doc.readyState !== 'loading') init();
  else doc.addEventListener('DOMContentLoaded', init);
  doc.addEventListener('shopify:section:load', init);
})();